import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchWorkplace(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/workplace/${id}/show-admin`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
